var t = { icon: { tag: "svg", attrs: { viewBox: "0 0 100 100", focusable: "false", fill: "currentColor" }, children: [{ tag: "g", attrs: { "fill-rule": "nonzero" }, children: [{ tag: "path", attrs: { d: "M50 0a50 50 0 100 100A50 50 0 0050 0z" } }, { tag: "path", attrs: { d: "M26.1 45.33h47.79a4.66 4.66 0 110 9.32h-47.8a4.66 4.66 0 110-9.32z", fill: "#FFF" } }] }] }, name: "delete", theme: "twotone" };
export {
  t as default
};
